module.exports = __webpack_public_path__ + "img/tu3.b9297ac1.png";